<div class="wrapper">
  @if (showHeading) {
    <div class="heading text-type-2">{{ data?.heading }}</div>
    @if (data?.subheading) {
      <div class="description text-type-10">{{ data?.subheading }}</div>
    }
  }
  @if (data?.subType === 'onlyBidItem' || data?.subType === 'onlyMaterial') {
    <app-delivery-details-form
      (onDeletePicture)="deletePicture($event)"
      [customFields]="customFields"
      [form]="getFormGroup(form, selectedMaterialId)"
      [selectedMediaFiles]="selectedMediaFiles"
      [uom]="data.uom"
      />
  }
  @if (data?.subType === 'bidItemWithMaterials') {
    <app-dropdown
      [closeOnEverySelect]="true"
      [enableMultiple]="true"
      [options]="materialOptions"
      [parentFormGroup]="materialForm"
      class="mb-[20px]"
      controlName="materials"
      label="MATERIAL"
      />
    @for (material of data?.materials; track material) {
      <div
        [class.is-expanded]="selectedMaterialId === material.id"
        [id]="material.id"
        class="material-accordion"
        >
        <div class="material-header flex justify-between items-center">
          <div
            (click)="selectLineItem(material.id)"
            class="left flex justify-start items-center gap-[12px] grow"
            >
            <div class="details text-type-8">
              {{ material.heading }}
            </div>
          </div>
          <div class="right flex justify-center items-center gap-[10px]">
            <div class="chevron">
              <mat-icon
                (click)="selectLineItem(material.id)"
                [svgIcon]="selectedMaterialId === material.id ? 'chevron-up' : 'chevron-down'"
                class="chevron-icon"
                />
            </div>
            <div class="menu-section">
              <mat-icon
                [matMenuTriggerFor]="menu"
               
                class="menu-icon"
                >more_horiz
              </mat-icon>
              <mat-menu #menu="matMenu">
                <button (click)="deleteLineItem(material.id)" mat-menu-item>
                  <mat-icon svgIcon="trash" />
                  Delete material
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
        @if (selectedMaterialId === material.id) {
          <div
            class="material-content"
            >
            <app-delivery-details-form
              (onDeletePicture)="deletePicture($event)"
              [customFields]="customFields"
              [form]="getFormGroup(form, selectedMaterialId)"
              [selectedMediaFiles]="selectedMediaFiles"
              [uom]="material.uom"
              />
          </div>
        }
      </div>
    }
    @if (showHeaderDetails) {
      <div
        class="header-details mt-[40px]"
        >
        @if (!!getFormGroup(form, selectedMaterialId).controls['comment']) {
          <div
            class="comment-section"
            >
            <app-text-area
              [parentFormGroup]="getFormGroup(form, selectedMaterialId)"
              controlName="comment"
              label="COMMENT"
              />
          </div>
        }
        @if (selectedMediaFiles.length) {
          <app-pictures-section
            (onDelete)="deletePicture($event)"
            [pictures]="selectedMediaFiles"
            class="pictures-section"
            />
        }
        @if (showLocationSection(selectedMaterialId)) {
          <app-location-station-card
            (onDelete)="deleteLocation(selectedMaterialId)"
            [latitude]="getFormGroup(form, selectedMaterialId)?.controls?.latitude?.value"
            [longitude]="getFormGroup(form, selectedMaterialId)?.controls?.longitude?.value"
            [locationText]="getFormGroup(form, selectedMaterialId)?.controls?.location?.value"
            [stationRange]="getFormGroup(form, selectedMaterialId)?.controls?.station_range?.value"
            [form]="getFormGroup(form, selectedMaterialId)"
            [recordLabel]="'delivery'"
            class="location-section"
            />
        }
      </div>
    }
  }
</div>
